// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","curseAuto":"Table_curseAuto__VgSPp","actions":"Table_actions__zexxr","actionItem":"Table_actionItem__ZJN5S"};